// WHICH OF THE CUT'S UIDS ARE THE ELEVATION HALF.
//
// GET /scope/uids streams the picked levels' own elements first and the
// elements the elevation switches added after them, and reports where the
// join is as `onLevelCount`. So the extras are the tail, exactly, and
// slicing costs nothing - where asking the route to send the list a second
// time would cost its size (5,557 Revit UniqueIds is ~260 KB).
//
// WHY THE EXTRAS HAVE TO BE SEPARABLE AT ALL: they are registered as a
// server-side selection so the quantities table, the stats, the totals and
// the status write can be narrowed by them. The level half needs no such
// treatment - it is expressible as names.
export function extrasOf(r) {
  const uids = (r && r.uids) || [];
  const n = Number(r && r.onLevelCount);
  // NO onLevelCount MEANS NO ELEVATION HALF, not "all of them are extras".
  // An older server, or a page with the switches off, answers without the
  // field; treating that as "every uid is an extra" would register the
  // whole level as a selection and narrow the table to itself.
  if (!Number.isFinite(n) || n < 0) return [];
  if (uids.length <= n) return [];
  return uids.slice(n);
}
